// deps
import React, { memo, ReactElement } from "react";

//components
import { SwiggyInstrumentsPaymentMethodV4 } from "./v4";

//interface
import {
    PaymentMethodProps,
    SwiggyInstrumentsPaymentGroup,
    SwiggyInstrumentsPaymentMethodData,
} from "@payment-ui/interfaces";

//context

interface SwiggyInstrumentsProps extends PaymentMethodProps {
    methodData: SwiggyInstrumentsPaymentMethodData;
    paymentActions: SwiggyInstrumentsPaymentGroup["paymentActions"];
    paymentAmount: string;
    paymentGroupBanner?: ReactElement | null;
}

function SwiggyInstrumentsPaymentMethod(props: SwiggyInstrumentsProps): ReactElement {
    return <SwiggyInstrumentsPaymentMethodV4 {...props} />;
}

export default memo(SwiggyInstrumentsPaymentMethod);
